/* Halftime — menu du mode Retro Gaming, version 32 bits (esprit FIFA 98 → FIFA 07, PES 6).
   Se greffe sur le menu existant (surcouche .vja) sans changer sa navigation ni le panier :
   · la colonne de droite prend toute la largeur restante et devient une « scène » ;
   · la scène montre les vrais produits et les vraies catégories du choix en cours :
       collection → présentoir de maillots en 3D (détourage s'il existe, sinon photo produit),
       catégorie avec sous-menus → vignettes des sous-catégories avec leur premier maillot,
       Collections → les 6 collections du vestiaire, Box Mystère → la box et des maillots floutés,
       Tirs au but → la cage, Mon club → les maillots du club, Vestiaire → le contenu du panier ;
   · bandeau d'infos défilant en bas (dernières arrivées), comme le ticker des jeux de l'époque.
   Rien en mode classique ; « réduire les animations » coupe les défilements et rotations.
   Données : /collections/<handle>/products.json, /search/suggest.json, /cart.js (lecture seule). */
(function () {
  'use strict';
  var H = document.documentElement, ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var O = null, stage = null, lastKey = '', tok = 0, timers = [], tickDone = false, D = null;
  function retro() { return H.classList.contains('vj-retro'); }
  function calm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches || H.classList.contains('vj-calm'); } catch (e) { return false; } }
  function $(s, r) { return (r || document).querySelector(s); }
  function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function data() { if (!D) { try { D = JSON.parse($('#vja-data').textContent); } catch (e) { D = {}; } } return D; }
  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return ''; } }
  function handleOf(p) { var m = /\/collections\/([^\/?#]+)/.exec(p || ''); return m ? m[1] : ''; }
  function sized(u, w) { return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; }
  function euros(v) { var n = Number(v); if (!isFinite(n)) return ''; return (n % 1 ? n.toFixed(2).replace('.', ',') : n) + ' €'; }
  function short(t) { return String(t || '').replace(/^maillot\s+/i, ''); }
  function later(f, ms) { var id = setTimeout(f, ms); timers.push(id); return id; }
  function stopTimers() { timers.forEach(function (t) { clearTimeout(t); clearInterval(t); }); timers = []; }

  /* --- lectures réseau, gardées en cache le temps de la visite --- */
  var CACHE = {};
  function getJSON(u) {
    if (!CACHE[u]) CACHE[u] = fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .catch(function () { delete CACHE[u]; return null; });
    return CACHE[u];
  }
  /* produits disponibles d'une collection → { t, u, imgs[], price } ; imgs = détourage face, puis photo */
  function products(h, n) {
    return getJSON(ROOT + 'collections/' + h + '/products.json?limit=' + (n || 12)).then(function (j) {
      return ((j && j.products) || []).filter(function (p) { return p.images && p.images.length && (p.variants || []).some(function (v) { return v.available; }); }).map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0], cut = data().cut ? data().cut.replace('HANDLE', p.handle).replace('NUM', 2) : '';
        return { t: p.title, u: ROOT + 'products/' + p.handle, imgs: [sized(cut, 700), sized(p.images[0].src, 700)].filter(Boolean), price: euros(v.price), size: v.title !== 'Default Title' ? v.title : '' };
      });
    });
  }
  /* image avec repli : détourage d'abord, photo ensuite */
  function imgTag(it, cls, alt) { var i = el('img', cls || ''); i.alt = alt == null ? it.t : alt; i.decoding = 'async'; i.loading = 'lazy'; var k = 0; i.onerror = function () { k++; if (it.imgs[k]) i.src = it.imgs[k]; else i.remove(); }; i.src = it.imgs[0]; return i; }

  /* --- arbre du menu (données du thème) --- */
  function findNode(p, list) {
    list = list || data().menu || [];
    for (var i = 0; i < list.length; i++) { var n = list[i]; if (n.u && path(n.u) === p && n.c && n.c.length) return n; var f = n.c && findNode(p, n.c); if (f) return f; }
    return null;
  }
  function myClubName() {
    try { for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (/^vjg:p:/.test(k)) { var v = JSON.parse(localStorage.getItem(k) || '{}'); if (v && v.club) return v.club; } } } catch (e) {}
    return '';
  }

  /* ================= les scènes ================= */
  function frame(cls, html) { stage.innerHTML = ''; var f = el('div', 'h32-sc ' + cls, html || ''); stage.appendChild(f); return f; }
  function loading(label) { frame('h32-load', '<span class="h32-ld"></span><b>' + esc(label || 'CHARGEMENT') + '</b>'); }

  /* présentoir 3D : le maillot au centre tourne doucement, les autres reculent sur les côtés */
  function kit(items, opt) {
    opt = opt || {};
    if (!items.length) return emblem(opt.emptyGlyph || 'HT', opt.empty || 'BIENTÔT DE RETOUR EN STOCK');
    items = items.slice(0, 9);
    var f = frame('h32-kit', '<div class="h32-floor"></div><div class="h32-spot"></div><div class="h32-row"></div>' +
      '<button type="button" class="h32-nav p" aria-label="Maillot précédent">◀</button><button type="button" class="h32-nav n" aria-label="Maillot suivant">▶</button>' +
      '<div class="h32-cap"><span class="h32-no"></span><b></b><span class="h32-pr"></span></div>' + (opt.badge ? '<span class="h32-badge">' + esc(opt.badge) + '</span>' : ''));
    var row = $('.h32-row', f), cur = 0, els = items.map(function (it, i) {
      var a = el('a', 'h32-k'); a.href = it.u; a.setAttribute('aria-label', it.t + (it.price ? ', ' + it.price : '')); a.appendChild(imgTag(it, '', ''));
      a.addEventListener('click', function (e) { if (i !== cur) { e.preventDefault(); go(i); } });
      row.appendChild(a); return a;
    });
    function place() {
      var n = els.length;
      els.forEach(function (a, i) {
        var d = i - cur; if (d > n / 2) d -= n; if (d < -n / 2) d += n;
        var ad = Math.abs(d), vis = ad <= 2;
        a.style.transform = 'translateX(' + d * 62 + '%) translateZ(' + (-ad * 190) + 'px) rotateY(' + (-d * 24) + 'deg)';
        a.style.opacity = vis ? (ad ? .62 - (ad - 1) * .25 : 1) : 0; a.style.zIndex = 10 - ad; a.classList.toggle('on', !d); a.tabIndex = vis ? 0 : -1;
        a.style.pointerEvents = vis ? '' : 'none';
      });
      var it = items[cur]; $('.h32-cap b', f).textContent = short(it.t); $('.h32-pr', f).textContent = it.price || ''; $('.h32-pr', f).hidden = !it.price;
      $('.h32-no', f).textContent = (cur + 1) + '/' + items.length + (it.size ? ' · ' + it.size : '');
    }
    function go(i) { cur = (i + els.length) % els.length; place(); auto(); }
    function auto() { if (calm() || els.length < 2) return; stopTimers(); later(function () { if (stage && stage.contains(f) && !f.matches(':hover')) go(cur + 1); else auto(); }, 3200); }
    $('.h32-nav.p', f).onclick = function () { go(cur - 1); }; $('.h32-nav.n', f).onclick = function () { go(cur + 1); };
    if (els.length < 2) { $('.h32-nav.p', f).hidden = $('.h32-nav.n', f).hidden = true; }
    place(); auto();
  }

  /* vignettes des sous-catégories, avec leur premier maillot */
  function grid(nodes, t) {
    nodes = nodes.filter(function (n) { return n.u; }).slice(0, 8);
    var f = frame('h32-grid'); f.style.setProperty('--cols', nodes.length <= 3 ? nodes.length : nodes.length === 4 ? 2 : 4);
    nodes.forEach(function (n, i) {
      var a = el('a', 'h32-tile', '<span class="h32-tg">' + esc(initials(n.t)) + '</span><b>' + esc(clean(n.t)) + '</b><small></small>'); a.href = n.u; a.style.setProperty('--d', i * 60 + 'ms');
      f.appendChild(a);
      var h = handleOf(path(n.u)); if (!h) return;
      products(h, 4).then(function (ps) {
        if (t !== tok || !ps) return;
        var sm = $('small', a); sm.textContent = ps.length ? (ps.length >= 4 ? '4+' : ps.length) + ' EN STOCK' : 'ÉPUISÉ';
        if (ps[0]) { var im = imgTag(ps[0], 'h32-ti', ''); a.insertBefore(im, a.firstChild); a.classList.add('img'); }
      });
    });
  }
  function clean(t) { return String(t || '').replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u2600-\u27BF]/gu, '').trim(); }
  function initials(t) { var w = clean(t).split(/\s+/).filter(function (x) { return x.length > 2; }); return ((w[0] || t)[0] + ((w[1] || '')[0] || '')).toUpperCase(); }

  /* les 6 collections du vestiaire (images du thème) */
  function packs() {
    var ps = (data().packs || []).filter(function (p) { return p.t; });
    var f = frame('h32-grid'); f.style.setProperty('--cols', ps.length > 4 ? 3 : 2);
    ps.forEach(function (p, i) {
      var a = el('a', 'h32-tile' + (p.img ? ' img ph' : ''), (p.img ? '<img class="h32-ti" alt="" loading="lazy" src="' + esc(p.img) + '">' : '<span class="h32-tg">' + esc(initials(p.t)) + '</span>') + '<b>' + esc(p.t) + '</b><small>' + (p.n ? p.n + ' ARTICLES' : '') + '</small>');
      a.href = ROOT + 'collections/' + p.h; a.style.setProperty('--d', i * 60 + 'ms'); f.appendChild(a);
    });
  }

  /* Box Mystère : la box tourne, des maillots possibles passent floutés derrière */
  function box(t) {
    var f = frame('h32-box', '<div class="h32-mist"></div><div class="h32-cube" aria-hidden="true"><i class="f1"><b>?</b></i><i class="f2"><b>?</b></i><i class="f3"><b>?</b></i><i class="f4"><b>?</b></i><i class="f5"></i><i class="f6"></i></div><div class="h32-floor"></div><span class="h32-badge">1 MAILLOT VINTAGE · CHOISI POUR TOI</span>');
    products('all', 12).then(function (ps) { if (t !== tok || !ps) return; var m = $('.h32-mist', f); ps.slice(0, 6).forEach(function (p, i) { var im = imgTag(p, '', ''); im.style.setProperty('--i', i); m.appendChild(im); }); });
  }

  /* tirs au but : la cage, le point de penalty, le ballon */
  function goal() {
    frame('h32-goal', '<div class="h32-crowd"></div><div class="h32-cage"><i class="h32-net"></i><i class="h32-gk"></i></div><div class="h32-pitch"><i class="h32-box6"></i><i class="h32-spot6"></i><i class="h32-ball"></i></div>' +
      '<div class="h32-board"><b>SÉANCE DE TIRS AU BUT</b><span>5 TIRS · MORT SUBITE · TU TIRES PUIS TU GARDES</span></div>');
  }

  /* emblème chromé pour les écrans sans produits (compte, options…) */
  function emblem(glyph, sub) {
    frame('h32-emb', '<div class="h32-hex"><b>' + esc(glyph) + '</b></div>' + (sub ? '<span class="h32-badge">' + esc(sub) + '</span>' : '') + '<div class="h32-floor"></div>');
  }

  /* Vestiaire = panier */
  function cart(t) {
    loading('OUVERTURE DU VESTIAIRE');
    getJSON(ROOT + 'cart.js?_=' + Date.now()).then(function (c) {
      if (t !== tok) return;
      var items = ((c && c.items) || []).filter(function (x) { return x.image; }).map(function (x) { return { t: x.product_title, u: x.url, imgs: [sized(x.image, 700)], price: euros(x.final_line_price / 100), size: x.quantity > 1 ? '×' + x.quantity : '' }; });
      if (!items.length) return emblem('0', 'TON VESTIAIRE EST VIDE');
      kit(items, { badge: (c.item_count || items.length) + ' RECRUE' + ((c.item_count || 0) > 1 ? 'S' : '') + ' · ' + euros(c.total_price / 100) });
    });
  }

  /* Mon club : ses maillots en stock (recherche du thème) */
  function club(t) {
    var name = myClubName(); if (!name) return emblem('?', 'CHOISIS TON CLUB DE CŒUR');
    loading('SCOUTING : ' + name.toUpperCase());
    getJSON(ROOT + 'search/suggest.json?q=' + encodeURIComponent(name) + '&resources[type]=product&resources[limit]=8').then(function (j) {
      if (t !== tok) return;
      var ps = ((j && j.resources && j.resources.results && j.resources.results.products) || []).filter(function (p) { return p.image && p.available !== false; }).map(function (p) { return { t: p.title, u: p.url, imgs: [sized(p.image, 700)], price: euros(p.price) }; });
      if (!ps.length) return emblem(name.slice(0, 3).toUpperCase(), 'AUCUN MAILLOT ' + name.toUpperCase() + ' EN CE MOMENT');
      kit(ps, { badge: name.toUpperCase() + ' · ' + ps.length + ' EN STOCK' });
    });
  }

  /* ================= choix de la scène selon la ligne sélectionnée ================= */
  function pick() {
    var a = O && $('.vja-list .vja-it.sel', O); if (!a) return null;
    var href = a.getAttribute('href') || '#';
    return { t: (($('span', a) || a).textContent || '').trim(), em: (($('em', a) || {}).textContent || '').trim(), p: href === '#' ? '' : path(href) };
  }
  function update() {
    if (!O || !stage) return;
    var on = O.classList.contains('on') && retro() && !$('.vja-menu', O).hidden;
    if (!on) { stopTimers(); lastKey = ''; return; }
    var s = pick(); if (!s) return;
    var key = s.t + '|' + s.p + '|' + s.em; if (key === lastKey) return; lastKey = key;
    stopTimers(); var t = ++tok, h = handleOf(s.p);
    if (s.em === 'JEU') return goal();
    if (/^collections$/i.test(s.t) && !s.p) return packs();
    if (/^mon club$/i.test(s.t)) return club(t);
    if (/^options$/i.test(s.t)) return emblem('OPT', 'SON · EFFET TÉLÉ · ANIMATIONS');
    if (/^\/cart/.test(s.p)) return cart(t);
    if (/box-mystere/.test(s.p)) return box(t);
    if (/^\/account/.test(s.p)) return emblem('J1', 'PROFIL JOUEUR · COMMANDES');
    if (/^\/pages\/rachat/.test(s.p)) { loading(); return products('all', 9).then(function (ps) { if (t === tok) kit(ps || [], { badge: 'ON RACHÈTE TES MAILLOTS' }); }); }
    if (s.em === '›') { var n = findNode(s.p); if (n) return grid(n.c, t); }
    if (h) { loading('ENTRÉE DES JOUEURS'); return products(h, 12).then(function (ps) { if (t === tok) kit(ps || [], { badge: s.em === 'TOUT' ? 'SÉLECTION COMPLÈTE' : '' }); }); }
    emblem('HT', '');
  }

  /* bandeau d'infos défilant : les dernières arrivées */
  function ticker() {
    if (tickDone || !O) return; tickDone = true;
    var tk = el('div', 'h32-tick', '<b>HALFTIME TICKER</b><div><span>NOUVELLE SAISON 2026-27 · BOX MYSTÈRE · TIRS AU BUT · CARTES CADEAUX</span></div>');
    tk.setAttribute('aria-hidden', 'true'); var ft = $('.vja-foot', O); O.insertBefore(tk, ft);
    products('all', 10).then(function (ps) {
      if (!ps || !ps.length) return;
      $('span', tk).textContent = ps.map(function (p) { return 'ARRIVAGE : ' + short(p.t).toUpperCase() + (p.price ? ' · ' + p.price : ''); }).join('   ★   ') + '   ★   BOX MYSTÈRE : UN VRAI MAILLOT CHOISI POUR TOI   ★   TIRS AU BUT : GAGNE TON TROPHÉE';
    });
  }

  function attach(o) {
    if (O === o) return; O = o; O.classList.add('h32');
    var card = $('.vja-card', O); stage = el('div', 'h32-stage'); stage.setAttribute('aria-live', 'off');
    card.insertBefore(stage, $('h3', card).nextSibling);
    ticker();
    var tm = 0; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(update, 60); }).observe(O, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    update();
  }
  function seek() { var o = $('.vja'); if (o) attach(o); }
  new MutationObserver(seek).observe(document.body || H, { childList: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seek); else seek();
})();
